import { render, staticRenderFns } from "./ReportEvMedica.vue?vue&type=template&id=49e126fd"
import script from "./ReportEvMedica.vue?vue&type=script&lang=js"
export * from "./ReportEvMedica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports